export var BeneficialOwnerRole;
(function (BeneficialOwnerRole) {
    BeneficialOwnerRole["Accountant"] = "ACCOUNTANT";
    BeneficialOwnerRole["Appointor"] = "APPOINTOR";
    BeneficialOwnerRole["AuthorisedSignatory"] = "AUTHORISED_SIGNATORY";
    BeneficialOwnerRole["Beneficiary"] = "BENEFICIARY";
    BeneficialOwnerRole["BusinessPartner"] = "BUSINESS_PARTNER";
    BeneficialOwnerRole["Ceo"] = "CEO";
    BeneficialOwnerRole["Cfo"] = "CFO";
    BeneficialOwnerRole["Chairman"] = "CHAIRMAN";
    BeneficialOwnerRole["CoBorrower"] = "CO_BORROWER";
    BeneficialOwnerRole["Coo"] = "COO";
    BeneficialOwnerRole["Director"] = "DIRECTOR";
    BeneficialOwnerRole["Guarantor"] = "GUARANTOR";
    BeneficialOwnerRole["Guardian"] = "GUARDIAN";
    BeneficialOwnerRole["Partner"] = "PARTNER";
    BeneficialOwnerRole["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
    BeneficialOwnerRole["President"] = "PRESIDENT";
    BeneficialOwnerRole["Secretary"] = "SECRETARY";
    BeneficialOwnerRole["ShareholderOfLessThan25Percent"] = "SHAREHOLDER_OF_LESS_THAN_25_PERCENT";
    BeneficialOwnerRole["SupportStaff"] = "SUPPORT_STAFF";
    BeneficialOwnerRole["ThirdPartyAuthority"] = "THIRD_PARTY_AUTHORITY";
    BeneficialOwnerRole["Treasurer"] = "TREASURER";
    BeneficialOwnerRole["Trustee"] = "TRUSTEE";
})(BeneficialOwnerRole || (BeneficialOwnerRole = {}));
//# sourceMappingURL=BeneficialOwnerRole.js.map